var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstudiante7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 94,
    viewBox: "0 0 57 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60001 73.57L19.72 62.94V32.56L1.60001 43.19V73.57Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.390015 44.29L1.60001 44.98V73.57L0.390015 72.98V44.29Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.58 71.04L39.54 61.18V41.91L22.58 51.77V71.04Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    fill: "#EAEAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 54.5V51.7H22.58V53.62L39.65 63.48L56.61 53.62",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.65 82.75L56.61 72.89V53.62L39.65 63.48V82.75Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.61 51.7L39.54 41.84L22.58 51.7L39.65 61.56L56.61 51.7Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.13 40.69C50.35 37.17 51.13 30.69 50.6 28.01C50.3952 26.7076 49.9619 25.4516 49.32 24.3C49.2309 24.0911 49.1238 23.8904 49 23.7C48.1479 22.688 47.109 21.8494 45.94 21.23C37.79 17.01 35.19 18.73 34.41 20.15C31.17 23.67 32.33 36.69 32.33 36.69L30.33 44.61C19.51 50.3 18.59 53.67 20.13 71L23.94 73.11C24.34 60.48 24.77 55.32 34.47 52.05C29.64 57.31 29.56 63.45 30.79 77.33L34.6 79.4C35.31 66.71 37.07 60.76 42.16 57.08C45.95 54.33 49.78 53.56 49.36 48.9C49.13 45.93 48.13 43.13 48.13 40.69Z",
    fill: "#252525",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54 47.82C27.3 55 31.8 55 33 50.05L29.54 47.82Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.61 13.27C34.26 10.71 35.45 5.59001 39.83 7.93001C44.21 10.27 35.61 13.27 35.61 13.27Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M33.84 25.29C33.7974 27.5546 33.9043 29.8195 34.16 32.07C34.3344 33.4211 34.3344 34.7889 34.16 36.14",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35 16.57C34.94 18.57 35.71 20.52 38.11 20.78L37.85 22C37.65 23.13 42.77 24.58 43.49 20.51C43.8116 18.1494 44.4858 15.8504 45.49 13.69C46.05 12.39 37.89 7.24001 36.12 11.6C35.5316 13.2008 35.1551 14.8716 35 16.57Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.71 19.38C44.32 17.07 45.79 17.53 46.51 13.45C47.23 9.37 43.91 6.13 39.83 7.93C36.11 6.24 35.61 11.93 35.61 11.93C36.72 10.17 42.53 15.26 42.53 15.26C42.53 15.26 43.21 12.34 44.53 13.26C45.85 14.18 43.47 17.38 43.47 17.38C43.47 17.38 43.09 21.7 43.71 19.38Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.13 71C10.83 75.87 16.71 79.51 23.94 73.11L20.13 71Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.79 77.28C22.58 81.34 26.79 87.28 34.6 79.4L30.79 77.28Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    fill: "#DEDEDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 53.34V50.78L0.390015 42.53V44.29L33.18 63.16L51.3 52.54",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L51.3 82.92V52.54L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 50.78L18.52 31.91L0.390015 42.53L33.18 61.41L51.3 50.78Z",
    fill: "#EAEAEA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.18 93.54L31.98 92.94V62.56L33.18 63.16V93.54Z",
    fill: "#CACACA",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.46 46.78L24.82 54.19L16.21 49.24L28.84 41.83L37.46 46.78Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.22 38.01L27.28 23.96L16.71 24.05L24.65 38.09L35.22 38.01Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M32.86 37.57C26 35 22.07 38.44 31.8 40.48L32.86 37.57Z",
    fill: "#B1ADA2",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.55 7.35C34.16 5.35 42.93 5.19 43.66 8.71C44.39 12.23 42.31 11.78 42.31 11.78L41.08 11L37.55 7.35Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 9.89C44.22 3.72 36.28 4.33 40 6.52C43.72 8.71 45.9 9.89 45.9 9.89Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.55 7.35C33.09 6.69 34.15 12.35 37.06 9.43C39.97 6.51 37.55 7.35 37.55 7.35Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M35.61 9.42999C32.87 12.11 34.32 14.09 35.61 13.27V9.42999Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9 9.89001C47.01 7.08001 43.13 4.45001 43.43 6.69001C43.5621 7.37965 43.8545 8.02857 44.2835 8.58443C44.7126 9.14029 45.2663 9.58751 45.9 9.89001Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.28 12.82C38.62 14.82 32.03 12.17 40.15 10.03L41.28 12.82Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M44.76 31.38C44.9 34.81 44.17 37.48 43.42 38.09C42.13 39.09 32.86 37.57 32.86 37.57L31.8 40.48C31.8 40.48 40.93 44 45.3 43C46.4776 42.6487 47.4692 41.8475 48.06 40.77",
    fill: "#252525"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M44.76 31.38C44.9 34.81 44.17 37.48 43.42 38.09C42.13 39.09 32.86 37.57 32.86 37.57L31.8 40.48C31.8 40.48 40.93 44 45.3 43C46.4776 42.6487 47.4692 41.8475 48.06 40.77",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstudiante7);
export default __webpack_public_path__ + "static/media/Estudiante7.2de939df6b66a384696d77e55687be2e.svg";
export { ForwardRef as ReactComponent };